import React, { Component } from "react";
import { Col, Row, Image } from "react-bootstrap";

export default class Univerdidad extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {}
  render() {
    return (
      <div className="navMargin" style={{ height: "100%" }}>
        <section
          style={{
            paddingTop: "2%",
            backgroundColor: "#352a35",
            display: "flex",
            flexDirection: "column",
            height: "auto",
            minHeight: "100%"
          }}
        >
          <p
            style={{
              color: "white",
              textAlign: "center",
              fontSize: "60pt",
              fontWeight: "Bold"
            }}
          >
            Universidad DTCH
          </p>
          <Image
            src={require("../../img/lineUniversidad.png")}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block"
            }}
            responsive
          />
          <div style={{ height: 25 }} />
          <div className="container-fluid">
            <Row>
              <Col xs={12} md={4}>
                <div
                  style={{
                    backgroundColor: "#cde6ea",
                    borderRadius: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    padding: 15,
                    width: "100%",
                    paddingTop: 130,
                    marginTop: 115,
                    minHeight: 400
                  }}
                >
                  <div style={{ position: "absolute", top: -115 }}>
                    <Image
                      src={require("../../img/uniMaletin.png")}
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        display: "block"
                      }}
                      responsive
                    />
                  </div>
                  <p
                    style={{
                      color: "#352a35",
                      fontSize: "18pt",
                      fontWeight: "bold"
                    }}
                  >
                    MISIÓN
                  </p>
                  <p
                    style={{
                      color: "#352a35",
                      textAlign: "justify",
                      fontSize: "14pt"
                    }}
                  >
                    Contribuir a la formación y al desarrollo del talento y
                    capital intelectual y humano a través del diseño,
                    implementación y evaluación de programas de educativos de
                    nivel superior, con altos estándares de calidad y servicio.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div
                  style={{
                    backgroundColor: "#cde6ea",
                    borderRadius: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    padding: 15,
                    width: "100%",
                    paddingTop: 130,
                    marginTop: 115,
                    minHeight: 400
                  }}
                >
                  <div style={{ position: "absolute", top: -115 }}>
                    <Image
                      src={require("../../img/uniOjo.png")}
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        display: "block"
                      }}
                      responsive
                    />
                  </div>
                  <p
                    style={{
                      color: "#352a35",
                      fontSize: "18pt",
                      fontWeight: "bold"
                    }}
                  >
                    VISIÓN
                  </p>
                  <p
                    style={{
                      color: "#352a35",
                      textAlign: "justify",
                      fontSize: "14pt"
                    }}
                  >
                    Ser una institución educativa, de investigación y
                    consultoría, con un sólido reconocimiento a nivel naconal,
                    que atiende las necesidades el sector educativo, empresarial
                    y social, con asertividad y calidad.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div
                  style={{
                    backgroundColor: "#cde6ea",
                    borderRadius: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    padding: 15,
                    width: "100%",
                    paddingTop: 130,
                    marginTop: 115,
                    minHeight: 400
                  }}
                >
                  <div style={{ position: "absolute", top: -115 }}>
                    <Image
                      src={require("../../img/uniBookmark.png")}
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        display: "block"
                      }}
                      responsive
                    />
                  </div>
                  <p
                    style={{
                      color: "#352a35",
                      fontSize: "18pt",
                      fontWeight: "bold"
                    }}
                  >
                    VALORES
                  </p>
                  <p
                    style={{
                      color: "#352a35",
                      textAlign: "justify",
                      fontSize: "14pt"
                    }}
                  >
                    - Innovación<br /> - Calidad<br /> - Congruencia<br /> -
                    Asertividad<br /> - Disciplina<br /> - Excelencia<br /> -
                    Respeto<br /> - Servicio
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    );
  }
  componentDidMount() {}
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/universidad/index.js